/* BD V1.5.12 route-aware runtime loader. Existing modules stay unchanged; only unnecessary page-level loads are skipped. */
(function(){
'use strict';
if(window.__BD_EDUCATION_RUNTIME_LOADING)return;
window.__BD_EDUCATION_RUNTIME_LOADING=true;
var script=document.currentScript;
var source=script&&script.src;
if(!source){window.__BD_EDUCATION_RUNTIME_STATUS='NO_SOURCE';return;}
function asset(filename){return(window.BDThemeAssets&&window.BDThemeAssets[filename])||new URL(filename,source).href;}
var body=document.body;
var path=window.location.pathname||'';
var isProduct=body&&body.classList.contains('template-product');
var isCollection=body&&body.classList.contains('template-collection');
var isSearch=body&&body.classList.contains('template-search');
var isFunding=path==='/pages/finanzierung';
var hasExpertDirectory=!!document.querySelector('[data-expert-directory]');
var files;
if(isProduct||isCollection){
  files=['theme-v13-core.js','theme-v13-enhancements.js','theme-v14-enhancements.js','theme-v14-hardening.js'];
}else if(isSearch){
  files=['theme-v13-core.js','theme-v14-hardening.js'];
}else if(isFunding){
  files=['theme-v13-core.js'];
}else if(hasExpertDirectory){
  files=['theme-v12-base.js','theme-v14-hardening.js'];
}else{
  files=['theme-v12-base.js'];
}
window.__BD_EDUCATION_RUNTIME_PROFILE=isProduct?'product':isCollection?'collection':isSearch?'search':isFunding?'funding':hasExpertDirectory?'expert':'base';
function load(i){
  if(i>=files.length){window.__BD_EDUCATION_RUNTIME_STATUS='LOADED:'+window.__BD_EDUCATION_RUNTIME_PROFILE;return;}
  var node=document.createElement('script');
  node.src=asset(files[i]);
  node.async=false;
  node.onload=function(){load(i+1);};
  node.onerror=function(){window.__BD_EDUCATION_RUNTIME_STATUS='LOAD_ERROR:'+files[i];};
  document.head.appendChild(node);
}
load(0);
})();
